import { render } from "./UiMessageModal.vue?vue&type=template&id=4ab8b75c&lang=pug"
import script from "./UiMessageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UiMessageModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__